import { Player } from "@/services/bedrock";

export interface Fan {
  id: string;
  guid: string;
  displayName: string;
  email: string | null;
  phoneNumber: string | null;
  stateCode: string | null;
  defaultLanguage: string | null;
  internalIdentifier: string | null;
  avatarUrl: string | null;
  notes: string | null;
  fanType: "customer" | "partner";
  sourceSystem: FanSourceSystem;
  sourceCategory: "manual" | "api" | "integration";
  active: boolean;
  externalIdentities: FanExternalIdentities[];
  latestActivity?: FanActivity;
  player?: Player;
  createdAt: string;
  updatedAt: string;
}

export type FanSourceSystem = "FB" | "ZL" | "GL" | "SC" | "TE" | "LI" | "BE" | "IF" | "EX";

export const fanSourceNames: Record<FanSourceSystem, string> = {
  FB: "Facebook",
  ZL: "Zillow",
  LI: "LinkedIn",
  TE: "TotalExpert",
  GL: "Google",
  SC: "SocialCoach",
  IF: "Imported Review",
  EX: "Experience.com",
  BE: "Birdeye",
};

interface FanExternalIdentities {
  id: number;
  sourceSystem: string;
  displayName: string | null;
  username: string | null;
  profileUrl: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface FanActivity {
  id: number;
  guid: string;
  activityType:
    | "review_received"
    | "form_request_sent"
    | "form_response_submitted"
    | "fan_merged_from"
    | "fan_merged_into"
    | "player_changed"
    | "possible_duplicate_email"
    | "response_moved_from"
    | "response_moved_to";
  subjectType: string | null;
  subjectId: number | null;
  metadata: Record<string, any> | null;
  occurredAt: string;
  createdAt: string;
  updatedAt: string;
}
